import {styled} from '../../styled-components';
import {TableRowStyle} from '../TableRow';
import {TableCellStyle} from '../TableCell';

export const TableHeadStyle = styled.thead`
    display: table-header-group;

    > ${TableRowStyle} {
        background: ${props => props.theme.color.primary.main};
        height: ${props => props.theme.spacing.units(3)};
        color: rgba(255, 255, 255, 0.5);
        text-transform: uppercase;

        > ${TableCellStyle} {
            border-bottom: none;
            font-size: ${props => props.theme.typography.pxToRem(10)};
        }
    }
`;
